// extracted by mini-css-extract-plugin
export default {"parent":"style_parent__2cZ11","container":"style_container__+G8bO","frame":"style_frame__RbnrG","content":"style_content__Km7IB","crop":"style_crop__fLyGH"};